export default {
    profile: 'Profile',
    invoices: 'Invoices',
    logout: 'Logout',
};
